module.exports = __webpack_public_path__ + "static/media/linux-icon.2f654cdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/linux-icon.png
// module id = 956
// module chunks = 1